/**
 * Created by mac on 4/28/20
 */

const EditorCardTable = function (...args) {
    TileTable.call(this, ...args);

    this.selected = new SelectionSet();
    this.blocks = [];
    this.selectBlocksMode = false;
    this.snapMode = false;
    this.setGrid();
};

EditorCardTable.prototype = Object.create(TileTable.prototype);
EditorCardTable.constructor = EditorCardTable;

EditorCardTable.prototype.getAmountOfCards = function () {
    return this.cards.reduce((count) => count + 1, 0);
};
EditorCardTable.prototype._calcRectSuper = EditorCardTable.prototype.calcRect;
EditorCardTable.prototype.calcRect = function () {
    return cc.rect(0, 0, this.canvas.width, this.canvas.height);
};

EditorCardTable.prototype.setOrientation = function (orientation) {
    this.orientation = orientation;

    this.canvas = this.getCanvas();
    this.setGrid();

    const screen = Game.currentGame.level.content.screens[Game.currentGame.pagination.getCurrent()];
    let cards = screen.cards;
    if (!cards || screen.horizontalCards && screen.horizontalCards.length && (orientation === TileTable.ORIENTATION_HORIZONTAL)) {
        cards = screen.horizontalCards;
    }
    this.setCards(cards, TileTable.ListMagicCards(screen), screen.maxValue);
    if (this.snapMode) {
        this.toggleSnapMode();
        this.toggleSnapMode();
    }
    this.flipNormalize();
    this.setRect();
    this.onResize();
    Editor.currentEditor.history.reset();
    Editor.currentEditor.save();

    this.clearSelection();
    if (this.selectBlocksMode) {
        this.updateBlocks();
    }
    this.trigger("editorChangeOrientation");
};

EditorCardTable.prototype.getOrientation = function () {
    return this.orientation;
};

EditorCardTable.prototype.needAdaptToCanvas = function () {
    const rect = this._calcRectSuper();
    if (this.getOrientation() === TileTable.ORIENTATION_HORIZONTAL) {
        return rect.height > this.canvas.height;
    } 
    return rect.width > this.canvas.width;
};

EditorCardTable.prototype.recreate = function (card, newCard) {
    this.selected.delete(card);

    newCard.opened = card.opened;
    const index = this.cards.indexOf(card);
    this.cards[index] = newCard;
    this.trigger("recreate", card, newCard);

    Game.currentGame.counter.trigger();
};

EditorCardTable.prototype.unselect = function (card) {
    let toUnSelect = [card];
    if (this.selectBlocksMode) {
        const block = this.blocks.find((block) => block.cards.includes(card));
        block.select(false);
        toUnSelect = block.cards;
    }

    toUnSelect.forEach((card) => {
        this.selected.delete(card);
        this.selectCard(card, false);
    });
};

EditorCardTable.prototype.select = function (card) {
    let toSelect = [card];
    if (this.selectBlocksMode) {
        const block = this.blocks.find((block) => block.cards.includes(card));
        block.select(true);
        toSelect = block.cards;
    }

    toSelect.forEach((card) => {
        this.selected.add(card);
        this.selectCard(card, true);
    });
};

EditorCardTable.prototype.toggleSelectBlocksMode = function () {
    this.clearSelection();
    this.selectBlocksMode = !this.selectBlocksMode;
    if (this.selectBlocksMode) {
        this.createBlocks();
    } else {
        this.removeBlocks();
    }
};

EditorCardTable.prototype.setGrid = function () {
    this.grid = new EditorTableGrid(this.getCanvas(), Card.GRID_XY);
};

EditorCardTable.prototype.toggleSnapMode = function () {
    this.clearSelection();
    this.grid.clearCells();
    this.snapMode = !this.snapMode;
    if (!this.snapMode) {
        this.flipNormalize();
    }
    this.trigger("toggleSnapMode", this.snapMode);
};

EditorCardTable.prototype.createBlocks = function () {
    this.blocks = cleverapps.cardBlockHandler.findCardsClusters().map((block) => new EditorCardBlock(block));
    this.trigger("createCardsBlocks", this.blocks);
};

EditorCardTable.prototype.removeBlocks = function () {
    this.trigger("removeCardsBlocks");
    this.blocks = [];
};

EditorCardTable.prototype.updateBlocks = function () {
    this.removeBlocks();
    this.createBlocks();
};

EditorCardTable.prototype.getBlocks = function (selected) {
    return this.blocks.filter((block) => {
        if (selected) {
            return block.selected;
        } 
        return !block.selected;
    });
};

EditorCardTable.prototype.alignBlocks = function (deltaPos) {
    this.blocks.forEach((block) => {
        block.deactivateAlignPoints();
    });
    const selectedBlocks = this.getBlocks(true);
    const unSelectedBlocks = this.getBlocks(false);
    const eps = 20;
    const deviations = { x: {}, y: {} };

    unSelectedBlocks.forEach((unselected) => {
        selectedBlocks.forEach((selected) => {
            const selectedAlignLines = selected.getAlignLines();
            const unselectedAlignLines = unselected.getAlignLines();
            ["x", "y"].forEach((coord) => {
                selectedAlignLines[coord].forEach((selectedLine) => {
                    selectedLine[coord] += deltaPos[coord];
                    unselectedAlignLines[coord].forEach((unselectedLine) => {
                        const dif = unselectedLine[coord] - selectedLine[coord];
                        if (Math.abs(dif) < eps) {
                            deviations[coord][dif] = deviations[coord][dif] || [];
                            selectedLine[coord] += dif;
                            deviations[coord][dif] = deviations[coord][dif].concat([selectedLine, unselectedLine]);
                        }
                    });
                });
            });
        });
    });

    const minDeviation = {};
    ["x", "y"].forEach((coord) => {
        minDeviation[coord] = Object.keys(deviations[coord]).map((key) => Number(key)).sort((a, b) => Math.abs(b) - Math.abs(a))[0];

        if (minDeviation[coord] !== undefined) {
            deviations[coord][minDeviation[coord]].forEach((line) => {
                line.block.activateAlignPoint(line.align);
            });
        }
    });

    deltaPos.x += minDeviation.x || 0;
    deltaPos.y += minDeviation.y || 0;
};

EditorCardTable.prototype.cardHeld = function (card, maxDepth) {
    const q = new Set([card]);
    let depth = 0;
    while (q.size > 0) {
        const it = q.values();
        const p = it.next().value;
        q.delete(p);

        this.select(p);

        depth++;
        if (maxDepth !== undefined && depth >= maxDepth) {
            break;
        }

        const cardsToAdd = [];
        for (let i = this.cards.indexOf(p) - 1; i >= 0; i--) {
            if (q.has(this.cards[i])) {
                continue;
            }

            if (this.cards[i].overlaps(p)) {
                cardsToAdd.push(this.cards[i]);
            }
        }

        cardsToAdd.forEach((cardToAdd) => {
            q.add(cardToAdd);
        });
    }

    return true;
};

EditorCardTable.prototype.existOpenCardByLocation = function (pos) {
    return this.cards.filter((card) => card.x === pos.x && card.y === pos.y && card.isOpen()).length > 0;
};

EditorCardTable.prototype.selectArea = function (rect, baseCards) {
    this.clearSelection();

    const inArea = this.cards.filter((card) => Editor.currentEditor.isCardOnActiveLayer(card)
        && cc.rectIntersectsRect(card.onGetView().getBoundingBox(), rect));

    cleverapps.unique(baseCards.concat(inArea)).forEach((card) => {
        this.select(card);
    });
};

EditorCardTable.prototype.editorClicked = function (pos) {
    const center = cc.rectGetCenter(this.rect);
    pos = cc.pSub(pos, center);

    const orangery = Editor.currentEditor.orangery;

    if (!orangery.selected) {
        if (this.getSelectedCard()) {
            this.clearSelection();
        }
    } else {
        pos.x = Card.STICK_TO_GRID(pos.x, this.grid.step);
        pos.y = Card.STICK_TO_GRID(pos.y, this.grid.step);

        if (this.existOpenCardByLocation(pos)) {
            pos.x += Card.WIDTH / 2;
        }

        const command = this.createNewCardCommand({ ...orangery.selected, ...pos });

        Editor.currentEditor.history.add(command);
    }
};

EditorCardTable.prototype.randomizeCards = function () {
    this.cards.forEach((card) => {
        if (card.random) {
            card.value = undefined;
        }
    });

    if (cleverapps.config.type === "tile3") {
        Game.currentGame.generator.reset(this.cards, Editor.currentEditor.tileColorsEditor.getCurrentValue());
        this.cards.forEach((card) => {
            if (card.random) {
                card.setRandomValue();
            }
        });
        TileTable.REPAINT(this.cards);
        this.cards.forEach((card) => {
            card.trigger("changeValue");
        });
    }
};

EditorCardTable.prototype.insertCard = function (card, index) {
    if (index === undefined) {
        this.cards.push(card);
    } else {
        this.cards.splice(index, 0, card);
    }

    if (this.selectBlocksMode) {
        this.updateBlocks();
    }

    this.trigger("addEditor", card, index);

    Editor.currentEditor.save();
};

EditorCardTable.prototype.addNewCard = function (data) {
    let card;
    if (data.cardOptions || data.CardCtor) {
        const options = data.cardOptions || {};
        options.x = data.x;
        options.y = data.y;
        options.value = data.value || options.value;

        card = new (data.CardCtor || Card)(options);
        if (options.random) {
            card.value = undefined;
        }
    } else {
        card = TileFactory.Create(data);
    }

    card.magic = data.magic;
    card.open();
    card.setOwner(this);

    this.insertCard(card);

    if (!card.magic) {
        this.randomizeCards();
    }

    this.flipNormalize();

    Game.currentGame.counter.trigger();
    this.resort();
    Editor.currentEditor.save();

    return card;
};

EditorCardTable.prototype.putComponent = function (card, options) {
    if (options.cardOptions.marks) {
        const markType = options.cardOptions.marks[0];
        if (!card.marks) {
            card.marks = [];
        }

        let markIndex = -1;
        card.marks.forEach((mark, index) => {
            if (mark === markType || (mark.type && mark.type === markType)) {
                markIndex = index;
            }
        });

        if (markIndex === -1) {
            card.marks.push(new Mark(markType));
            card.trigger("addMark", markType);
        } else {
            card.marks.splice(markIndex, 1);
            card.trigger("removeMark", markType);
        }
        return;
    }

    const ComponentClass = options.cardOptions.componentCtor;
    const component = card.findComponent(ComponentClass);
    if (component) {
        component.onDestroy();
        card.removeComponent(ComponentClass);
    } else {
        const newComponent = new ComponentClass(card, options.cardOptions.components[0]);
        card.components.push(newComponent);
        const ComponentViewClass = newComponent.getViewClass();
        card.onGetView().addChild(new ComponentViewClass(newComponent));
    }

    Editor.currentEditor.save();
};

EditorCardTable.prototype.createNewCardCommand = function (data) {
    let card;
    return {
        redo: function () {
            if (card) {
                this.insertCard(card);
            } else {
                card = this.addNewCard(data);
            }
            return card;
        }.bind(this),

        undo: function () {
            this.removeCardEditor(card);
        }.bind(this)
    };
};

EditorCardTable.prototype.resort = function () {
    TileTable.RESORT(this.cards);
    this.trigger("editorUpdateZ", this.cards);
};

EditorCardTable.prototype.removeCardEditor = function (card) {
    const index = this.cards.indexOf(card);
    this.cards.splice(index, 1);

    this.trigger("removeCardEditor", card);

    if (this.selected.has(card)) {
        this.selected.delete(card);
    }

    this.randomizeCards();

    this.flipNormalize();

    if (this.selectBlocksMode) {
        this.updateBlocks();
    }

    Editor.currentEditor.save();
};

EditorCardTable.prototype.removeCardsEditor = function () {
    const cards = this.selected.listSelected();
    this.clearSelection();

    const commands = cards.map(function (card) {
        const prevIndex = card.getZ();
        return {
            redo: function () {
                this.removeCardEditor(card);
            }.bind(this),
            undo: function () {
                this.insertCard(card, prevIndex);
            }.bind(this)
        };
    }, this);

    Editor.currentEditor.history.add({
        redo: function () {
            commands.forEach((command) => {
                command.redo();
            });

            Game.currentGame.counter.trigger();
            Editor.currentEditor.save();
        },

        undo: function () {
            commands.forEach((command) => {
                command.undo();
            });

            this.randomizeCards();
            this.flipNormalize();
            Editor.currentEditor.save();
        }.bind(this)
    });
};

EditorCardTable.prototype.clearSelection = function () {
    this.selected.forEach(function (card) {
        this.selectCard(card, false);
    }, this);
    this.selected.clear();

    if (this.selectBlocksMode) {
        this.blocks.forEach((block) => {
            block.select(false);
        });
    }
};

EditorCardTable.prototype.selectAll = function () {
    this.clearSelection();
    this.cards.forEach(function (card) {
        this.selectCard(card, true);
        this.selected.add(card);
    }, this);

    if (this.selectBlocksMode) {
        this.blocks.forEach((block) => {
            block.select(true);
        });
    }
};

EditorCardTable.prototype.showCardsByLayers = function () {
    this.cards.forEach((card) => {
        card.trigger("setActive", Editor.currentEditor.isCardOnActiveLayer(card));
        card.trigger("setVisible", Editor.currentEditor.isCardVisible(card));
        if (cleverapps.config.type === "tile3") {
            card.trigger("setLayerDimmed", Editor.currentEditor.isCardBelowActiveLayer(card), this.selected.has(card));
        }
    });
};

EditorCardTable.prototype.editorRotateCardView = function (rotation) {
    const center = this.getSelectedCenter();
    const angle = rotation / 180 * Math.PI;
    const toRotate = this.selected.listSelected().concat(this.getBlocks(true));
    toRotate.forEach((node) => {
        const x = node.x - center.x;
        const y = node.y - center.y;
        this.trigger("editorMove", [node], {
            x: x * Math.cos(angle) + y * Math.sin(angle) - x,
            y: -x * Math.sin(angle) + y * Math.cos(angle) - y,
            r: rotation
        });
    });
};

EditorCardTable.prototype.editorCardMove = function (pos) {
    let cards = this.selected.listSelected();
    if (this.selectBlocksMode) {
        this.alignBlocks(pos);
    }
    if (this.snapMode) {
        this.grid.clearCells();
        cards.forEach((card) => {
            this.grid.setActive(true, card, pos);
        });
    }
    cards = cards.concat(this.getBlocks(true));
    this.trigger("editorMove", cards, pos);
};

EditorCardTable.prototype.editorCardMoveEnd = function (pos) {
    const cards = this.selected.listSelected().concat(this.getBlocks(true));

    if (this.selectBlocksMode) {
        this.alignBlocks(pos);
    }

    pos.x = Card.STICK_TO_GRID(pos.x, this.grid.step);
    pos.y = Card.STICK_TO_GRID(pos.y, this.grid.step);

    Editor.currentEditor.history.add({
        redo: function () {
            cards.forEach((card) => {
                card.setPosition({
                    x: card.x + pos.x,
                    y: card.y + pos.y,
                    r: card.r + pos.r
                });
            });

            this.trigger("editorMoveEnd", cards);
            Game.currentGame.counter.trigger();
            Editor.currentEditor.save();
        }.bind(this),

        undo: Editor.currentEditor.restoreCards(cards)
    });
    if (!this.snapMode) {
        this.flipNormalize();
    }
};

EditorCardTable.prototype.editorRotateCard = function (rotation) {
    const cards = this.selected.listSelected().concat(this.getBlocks(true));

    Editor.currentEditor.history.add({
        redo: function () {
            const center = this.getSelectedCenter();
            const angle = rotation / 180 * Math.PI;
            cards.forEach((card) => {
                const x = card.x - center.x;
                const y = card.y - center.y;
                card.setPosition({
                    x: card.x + x * Math.cos(angle) + y * Math.sin(angle) - x,
                    y: card.y + -x * Math.sin(angle) + y * Math.cos(angle) - y,
                    rotation: (card.getRotation() + rotation) % 360
                });
            });

            this.trigger("editorMoveEnd", cards);
            Game.currentGame.counter.trigger();
            Editor.currentEditor.save();
        }.bind(this),

        undo: Editor.currentEditor.restoreCards(cards)
    });
};

EditorCardTable.prototype.getSelectedCenter = function () {
    let rect = undefined;
    this.selected.forEach((card) => {
        if (!rect) {
            rect = cc.rect(card.x, card.y, 0, 0);
        } else {
            rect = cc.rectUnion(rect, cc.rect(card.x, card.y, 0, 0));
        }
    });

    return rect && cc.rectGetCenter(rect);
};

EditorCardTable.prototype.listMagicCards = function () {
    return this.cards.filter((card) => card.magic);
};

EditorCardTable.prototype.removeMagicCards = function () {
    const manualCards = this.cards.filter((card) => !card.magic);

    this.listMagicCards().forEach(function (card) {
        this.trigger("removeCardEditor", card);
    }, this);

    this.cards = manualCards;

    Editor.currentEditor.save();
};

EditorCardTable.prototype.removeAllCards = function () {
    const cards = this.cards.slice();

    Editor.currentEditor.history.add({
        redo: function () {
            this.cards.forEach((card) => {
                this.trigger("removeCardEditor", card);
            });
            this.cards = [];

            this.clearSelection();

            Editor.currentEditor.save();
        }.bind(this),

        undo: function () {
            cards.forEach(this.insertCard.bind(this));
        }.bind(this)
    });
};

EditorCardTable.prototype.flip = function (options) {
    const cards = this.selected.listSelected();

    Editor.currentEditor.history.add({
        redo: function () {
            const center = this.getSelectedCenter();
            cards.forEach((card) => {
                card.setPosition({
                    x: options.x ? 2 * center.x - card.x : card.x,
                    y: options.y ? 2 * center.y - card.y : card.y,
                    rotation: -card.getRotation()
                });
            });

            this.trigger("editorMoveEnd", cards);

            Game.currentGame.counter.trigger();

            Editor.currentEditor.save();
        }.bind(this),

        undo: Editor.currentEditor.restoreCards(cards)
    });
};

EditorCardTable.prototype.getSelectedCard = function () {
    return this.selected.values().next().value;
};

EditorCardTable.prototype.changeOrder = function (moveUp) {
    const otherCards = moveUp ? this.cards : this.cards.reverse();
    for (let i = otherCards.length - 2; i >= 0; i--) {
        const current = otherCards[i];
        if (!this.selected.has(current)) {
            continue;
        }

        for (let j = i + 1; j < otherCards.length; j++) {
            const other = otherCards[j];
            if (this.selected.has(other)) {
                break;
            }

            otherCards[j - 1] = other;
            otherCards[j] = current;

            if (current.overlaps(other)) {
                break;
            }
        }
    }

    this.cards = moveUp ? otherCards : otherCards.reverse();

    this.cards.forEach((card) => {
        card.trigger("updateZ");
    });

    this.flipNormalize();

    this.selected.forEach(function (card) {
        this.selectCard(card, true);
    }, this);

    Game.currentGame.counter.trigger();
    Editor.currentEditor.save();
};

EditorCardTable.prototype.selectCard = function (card, selected) {
    if (this.snapMode) {
        this.grid.setActive(selected, card);
    } else {
        card.trigger("editorColor", selected);
    }
};

EditorCardTable.IsMultiSelectPressed = function () {
    return cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.ctrl) || cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.meta);
};

EditorCardTable.CountCards = function (cards) {
    return cards.reduce((count, card) => {
        if (card.stack) {
            return count + card.amount;
        }

        return count + 1;
    }, 0);
};

EditorCardTable.COPY_MOVE_BY = {
    x: 60,
    y: 60
};

const SelectionSet = function () {
    this.set = new Set();
};

SelectionSet.prototype.listSelected = function () {
    return Array.from(this.set);
};

SelectionSet.prototype.add = function (...args) {
    const res = this.set.add.call(this.set, ...args);
    Editor.currentEditor.copyPaste.update();
    return res;
};

SelectionSet.prototype.delete = function (...args) {
    const res = this.set.delete.call(this.set, ...args);
    Editor.currentEditor.copyPaste.update();
    return res;
};

SelectionSet.prototype.clear = function (...args) {
    const res = this.set.clear.call(this.set, ...args);
    Editor.currentEditor.copyPaste.update();
    return res;
};

SelectionSet.prototype.has = function (...args) {
    return this.set.has.call(this.set, ...args);
};

SelectionSet.prototype.forEach = function (...args) {
    return this.set.forEach.call(this.set, ...args);
};

SelectionSet.prototype.values = function (...args) {
    return this.set.values.call(this.set, ...args);
};
